export default __webpack_public_path__ + "static/media/left-gray-arrow.4847d53a.svg";